export const openLink = (path) => {
  window.location.href = path;
};
